import fullScreenMenu from '../../plugins/fullscreenmenu.js';

fullScreenMenu.init();